<script setup lang="ts">
import { KButton } from "@kaleidoscope-solutions/ks-design-system"
import { CloseRingIcon } from "@kaleidoscope-solutions/ks-icons/vue/light"

import { useRegisterSW } from "virtual:pwa-register/vue"

const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW()

function close() {
  offlineReady.value = false
  needRefresh.value = false
}
</script>

<template>
  <div
    v-if="offlineReady || needRefresh"
    class="fixed right-0 bottom-0 m-6 space-y-4 rounded-lg border border-gray-400 bg-white p-4 shadow-md"
    role="alert"
  >
    <div class="relative">
      <div class="flex space-x-2">
        <div class="flex-1">
          <span v-if="offlineReady"> App ready to work offline </span>
          <span v-else>
            New version available, click on reload button to update.
          </span>
        </div>
        <CloseRingIcon
          class="size-4"
          @click="close"
        />
      </div>
      <div class="mt-3 flex justify-end space-x-2">
        <KButton
          variety="secondary"
          @click="close"
        >
          Close
        </KButton>
        <KButton
          v-if="needRefresh"
          @click="updateServiceWorker()"
        >
          Reload
        </KButton>
      </div>
    </div>
  </div>
</template>
